// 向超管后台发送消息

export type AdminPost = "route"

// 必须实现此接口
interface IAdminPostMessage {
  from: "return_admin"
  type: AdminPost
  data: object
}

interface IAdminPostRouteMessage extends IAdminPostMessage {
  type: "route"
  data: {
    path: string
  }
}

/**
 * 向超管后台发送路由消息
 * @param {string} path
 */
export function postRouteMessageToAdmin(path: string) {
  const msg: IAdminPostRouteMessage = {
    data: {
      path,
    },
    from: "return_admin",
    type: "route",
  }

  window.parent.postMessage(msg, "*")
}
